import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap';
import GenericTable from 'componentes/generic/GenericTable.js';

const StatusTable = ({ status, setIdStatus, setOpenModal }) => {
  const columns = [
    {
      accessorKey: 'descripcion',
      header: 'Status',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'tipostatus.descripcion',
      header: 'Tipo',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'idstatus',
      header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { idstatus } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                setIdStatus(idstatus);
                setOpenModal(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
            {/* <Button
                       variant="falcon-default"
                       size="sm"
                       title="Eliminar"
                       onClick={() => {
                         setIdMunicipioToDelete(idmunicipio);
                         setOpenConfirm(true);
                       }}
                     >
                       <FontAwesomeIcon icon="trash-alt" />
                     </Button> */}
          </>
        );
      }
    }
  ];
  return (
    <>
      <GenericTable
        data={status}
        title="Status"
        columns={columns}
        addAction={() => {
          setIdStatus(0);
          setOpenModal(true);
        }}
      ></GenericTable>
    </>
  );
};
StatusTable.propTypes = {
  status: PropTypes.array.isRequired,
  setIdStatus: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired
};
export default StatusTable;
